import { render, staticRenderFns } from "./RegistroArmaNuevaDialogComponent.vue?vue&type=template&id=77aa1582&scoped=true"
import script from "./RegistroArmaNuevaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroArmaNuevaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistroArmaNuevaDialogComponent.vue?vue&type=style&index=0&id=77aa1582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa1582",
  null
  
)

export default component.exports